module.exports = __webpack_public_path__ + "img/4-low.8faa692e.jpg";